<template>
  <div :class="['definition-wrapper', 'mono-choice', definition.id, {'error_validate': mandatoryValidation}, {'ok_validate': !mandatoryValidation && monoChoiceValue && (monoChoiceValue.key || monoChoiceValue.length > 0)}]">
    <definition-choice-api v-if="editable && isApiDomain"
      :definition="definition" :type="type" :authorization="authorization" :definitionContentId="definitionContentId" :language="language"
      :isNoSearch="isNoSearch" :content="content" :parentChoiceKeys="parentChoiceKeys" :object="object"
      @apiElementAdded="apiElementAdded" @apiCallResponse="apiCallResponse"
    />
    <div v-if="editable && !gallery && !radio" class="multiselect-wrapper">
      <multiselect
        :key="getDefinitionObjectKey(definition.id)"
        :options="getDomain()"
        track-by="value"
        label="value"
        :placeholder="getPlaceholder()"
        :selectLabel="getLang('enterForSelect')"
        :deselectLabel="getLang('enterForDelete')"
        :preserveSearch="true"
        :class="[{'choiceWithTask': definition.task && definition.task.length > 0 && editable}]"
        v-model="monoChoiceValue"
        @input="valueChanged"
        @open="openValue"
        @close="closeValue"
      >
        <template #singleLabel="{ option }">
          <i v-if="isIcons()" :class="['sherpa-icon','icon-' + option.key]"></i>
          {{ option.value }}
        </template>
        <template v-if="isIcons()" #option="{ option }">
          <i :class="['sherpa-icon','icon-' + option.key]"></i>
          <span> {{ option.value }} </span>
        </template>
        <template #noResult>
          {{ getLang('noResults') }}
        </template>
        <template #caret><span v-bind:class="{'active':isOpen}" class="arrow"><i class="fa fa-angle-down fa-2x"></i></span></template>
      </multiselect>
    </div>
    <div v-else-if="editable && radio" class="radio-wrapper">
      <p-radio v-for="(domain) in getDomain()" :key="domain.key"
        :name="definition.id"
        :class="[getPrettyClasses(radio), 'p-smooth', 'p-bigger', {'p-locked': !editable}]"
        color="primary"
        :value="domain.key"
        v-model="radioValue"
        @click.native="radioClick(domain.key)"
      >
        {{ domain.value }}
      </p-radio>
    </div>
    <div v-else-if="editable && gallery && showCarousel" class="gallery-wrapper">
      <div class="gallery-grid w3-container w3-show">
        <div v-for="domain in getDomain()" :key="domain.key"
          :class="['gallery-item', {'selected' : isSelected(domain.key)}]"
          @click="valueChanged(domain)"
        >
          <div class="gallery-img-wrapper">
            <iframe scrolling="no" :srcdoc="domain.value" class="gallery-img" />
            <div v-if="isLangLegend()" class="lang-legend">
              <span>{{ getLangCode() }}</span>
            </div>
          </div>
          <span class="gallery-title">{{ domain.desc }}</span>
        </div>
      </div>
    </div>
    <definition-read-only v-else :definitionId="definitionId" :definition="definition" :object="object" :visualDefinition="visualDefinition" />
    <transition name="fade" mode="out-in">
      <div v-if="showDescInfo() && this.showingDesc" class="show-desc">
        <i class="sherpa-icon icon-question"></i>
        <span v-html="object.domainValue[0].desc"></span>
        <button @click="closeDesc()"><i class="sherpa-icon icon-cerrar"></i></button>
      </div>
      <i v-else-if="showDescInfo()" class="show-desc sherpa-icon icon-question" @click="openDesc()"></i>
    </transition>
    <definition-task :class="[getDefinitionFieldClassTaskClass()]" v-if="definition.task && definition.task.length > 0"
      :definition="definition" :object="object" :definitionObject="definitionObject" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :language="language" :authorization="authorization" :type="type" :visuals="visuals" :apiparams="apiparams" :callTask="callTask"
      @refreshDefinition="taskValueChanged" @refreshDefinitionContent="refreshDefinitionContent" @taskLink="taskLink"
    />
  </div>
</template>

<script>
import DefinitionReadOnly from './readOnly'
import DefinitionTask from './task'
import DefinitionChoiceApi from './choiceApi'
import Multiselect from '@/components/shared/Multiselect.vue' // 'vue-multiselect ^2.1.6' component with TMD modifications
import moment from 'moment'
import transport from 'vue-definition-utils/src/utils/transport'
import language from '../language'
import SpinnerLoading from '@/components/shared/SpinnerLoading.vue'
import PrettyRadio from '@/components/shared/PrettyRadio.vue'

export default {
  name: 'definition-mono-choice',
  props: [
    'definition',
    'object',
    'definitionObject',
    'editable',
    'mandatoryValidation',
    'definitionId',
    'definitionContentId',
    'repeatableGroupCode',
    'gallery',
    'radio',
    'parentRepeatableGroupOpen',
    'requestObjectForAdd',
    'requestObjectForAddModified',
    'language',
    'visualDefinition',
    'authorization',
    'type',
    'visuals',
    'apiparams',
    'placeholder',
    'showCarousel',
    'callTask',
    'isApiDomain',
    'isNoSearch',
    'showDesc',
    'content',
    'parentChoiceKeys'
  ],
  components: {
    DefinitionReadOnly,
    DefinitionTask,
    Multiselect,
    SpinnerLoading,
    DefinitionChoiceApi,
    PrettyRadio
  },
  data () {
    return {
      monoChoiceValue: null,
      isOpen: false,
      perPageSlides: 6,
      radioValue: null,
      radioValueAux: null,
      showingDesc: true
    }
  },
  methods: {
    // 1. Launch validate mandatory event on value change
    valueChanged (domain) {
      var value = []
      if (!this.gallery) {
        if (this.monoChoiceValue) {
          if (Array.isArray(this.monoChoiceValue)) {
            value.push(this.monoChoiceValue[0])
          } else {
            value.push(this.monoChoiceValue)
          }
        }
      } else {
        value.push(domain)
      }
      this.object.domainValue = value
      this.$emit('validateMandatory', moment().valueOf(), this.object)
      this.showingDesc = true
    },
    taskValueChanged (object) {
      this.$emit('refreshDefinition', object)
    },
    closeValue () {
      this.isOpen = false
    },
    openValue () {
      this.isOpen = true
    },
    isExpanded () {
      var visualDef = this.visualDefinition.getDefinitionFields(this.definition)
      return visualDef && visualDef.class && visualDef.class.search('expanded') >= 0
    },
    isIcons () {
      var visualDef = this.visualDefinition.getDefinitionFields(this.definition)
      return visualDef && visualDef.class && visualDef.class.search('icons') >= 0
    },
    isLangLegend () {
      var visualDef = this.visualDefinition.getDefinitionFields(this.definition)
      return visualDef && visualDef.class && visualDef.class.search('lang-legend') >= 0
    },
    isSelected (domainKey) {
      return this.object.domainValue && this.object.domainValue.length > 0 && domainKey === this.object.domainValue[0].key
    },
    selectedGalleryPage () {
      var result = 0
      if (this.object.domainValue && this.object.domainValue.length > 0) {
        var domainIndex = -1
        for (var i = 0; i < this.definition.validation.domain.length && domainIndex < 0; i++) {
          if (this.definition.validation.domain[i].key === this.object.domainValue[0].key) {
            domainIndex = i
          }
        }
        if (domainIndex > -1) {
          result = parseInt(domainIndex / this.perPageSlides)
        }
      }
      return result
    },
    loadGalleryVisibility () {
      if (this.editable && this.gallery) {
        setTimeout(() => {
          if (this.$refs.carousel) {
            this.$refs.carousel.onResize()
            this.$refs.carousel.goToPage(this.selectedGalleryPage())
          }
        }, 200)
      }
    },
    getLang (key) {
      return language(this.language, key)
    },
    getLangCode () {
      return this.getLang().substr(0, 2).toUpperCase()
    },
    radioClick (key) {
      if (this.radioValueAux === key) {
        this.radioValue = null
        this.radioValueAux = null
      } else {
        this.radioValue = key
        this.radioValueAux = key
      }
      var domain = transport.methods.getDomainValue(this.definition.validation.domain, this.radioValue)
      this.monoChoiceValue = domain
      this.valueChanged()
    },
    getPrettyClasses (classesStr) {
      var result = ''
      var classes = classesStr.split(' ')
      if (classes) {
        for (var i = 0; i < classes.length; i++) {
          if (classes[i].substr(0, 2) === 'p-') {
            result += ' ' + classes[i]
          }
        }
      }
      return result
    },
    getPlaceholder () {
      var result = this.placeholder
      if (!result) {
        result = this.getLang('select')
      }
      return result
    },
    refreshDefinitionContent () {
      this.$emit('refreshDefinitionContent')
    },
    getDefinitionFieldClassTaskClass () {
      var result = null
      var definition = this.visualDefinition.getDefinitionFields(this.definition)
      if (definition) {
        result = definition.tasks
      }
      return result
    },
    getDomain () {
      var result = []
      if (this.definition.validation.domain) {
        for (var i = 0; i < this.definition.validation.domain.length; i++) {
          if (this.definition.validation.domain[i].visible) {
            result.push(this.definition.validation.domain[i])
          }
        }
      }
      return result
    },
    taskLink (obj) {
      this.$emit('taskLink', obj)
    },
    apiElementAdded (element) {
      this.monoChoiceValue = [element]
      this.valueChanged()
    },
    apiCallResponse () {
      if (this.monoChoiceValue) {
        this.monoChoiceValue = this.monoChoiceValue.filter(monoChoiceItem =>
          this.definition.validation.domain.some(domainItem => domainItem.key === monoChoiceItem.key)
        )
        this.valueChanged()
      }
    },
    showDescInfo () {
      return this.showDesc && this.object && this.object.domainValue && this.object.domainValue.length > 0 && this.object.domainValue[0].desc && this.object.domainValue[0].desc !== ''
    },
    closeDesc () {
      this.showingDesc = false
    },
    openDesc () {
      this.showingDesc = true
    },
    getDefinitionObjectKey (id) {
      let result = id
      if (this.parentChoiceKeys) {
        result += '_' + this.parentChoiceKeys
      }
      return result
    }
  },
  beforeMount () {
    if (this.object && this.definition.validation) {
      this.monoChoiceValue = transport.methods.getCheckedDomainValues(this.object.domainValue, this.definition.validation.domain)
      if (!this.monoChoiceValue) {
        this.monoChoiceValue = []
      }
      this.object.domainValue = this.monoChoiceValue

      if (this.monoChoiceValue && this.monoChoiceValue.length === 1) {
        this.radioValue = this.monoChoiceValue[0].key
        this.radioValueAux = this.monoChoiceValue[0].key
      }
    }
  },
  mounted () {
    this.loadGalleryVisibility()
  },
  watch: {
    mandatoryValidation (value) {
      // 2. if mandatory validation past...
      if (value && (value.validateKey === null || value.validateKey.trim() === '')) {
        // ... launch refresh definition event
        this.$emit('refreshDefinition', this.object)
      }
    },
    object (value) {
      if (value && value.domainValue) {
        this.monoChoiceValue = value.domainValue
      }
      if (this.monoChoiceValue.length === 1) {
        this.radioValue = this.monoChoiceValue[0].key
        this.radioValueAux = this.monoChoiceValue[0].key
      } else if (!this.monoChoiceValue || this.monoChoiceValue.length === 0) {
        this.radioValue = null
        this.radioValueAux = null
      }
    },
    parentRepeatableGroupOpen (parentRepeatableGroupOpen) {
      if (parentRepeatableGroupOpen) {
        this.loadGalleryVisibility()
      }
    }
  }
}
</script>

<style lang="scss">
.multiselect {
  height: 33px !important;
  min-height: 33px !important;
}
.multiselect--active {
  border: 1px solid #3485FE;
}
.multiselect__option {
  font-size: 12px;
}
.multiselect__tags {
  padding: 3px 40px 0 4px;
  font-size: 14px;
  min-height: 33px;
  height: 33px;
  border-radius: 3px;

  .multiselect__tag {
    padding: 7px 30px 6px 10px;
    font-size: 13px;
    font-family: inherit;
    margin-bottom: 0;
    border-radius: 0;
    margin-right: 5px;
    background-color: #d42e12;

    .multiselect__tag-icon {
      margin-right: 1px;
      border-radius: 0;
      top: 2px;
      bottom: 1px;
      right: 1px;

      &:after {
        font-size: 18px;
        line-height: 18px;
        color: #fff;
      }

      &:hover {
        background-color: #333;
      }
    }
  }
  .multiselect__input {
    font-size: 14px;
    font-family: "Noto Sans";
    border: 0 !important;
  }
  .multiselect__single {
    font-size: 14px;
    margin-bottom: 0;
    overflow: hidden;
    font-family: "Noto Sans";
    padding-left: 0;
  }
  .multiselect__placeholder {
    padding: 5px 0 0 4px;
    font-size: 14px;
    margin-bottom: 0;
    font-family: "Noto Sans";
  }
}
.multiselect__content-wrapper {
  .multiselect__option--highlight {
    background: #13BD38 !important;

    &:after {
      background: #13BD38 !important;
      display: none;
    }
  }
}
.multiselect__option--selected{
  &:after {
    display: none;
  }

  &.multiselect__option--highlight {
    background: #FF3654 !important;

    &:after {
      background: #FF3654 !important;
    }
  }
}
.radio-wrapper {
  float: left;
}
.pretty {
  margin: 9px 15px 9px 0;
}
.multiselect__tags {
  border: 1px solid #e8e8e8;
  border-radius: 2px!important;
  font-size: 14px;
  height: 33px!important;
  min-height: 33px!important;
  padding: 2px 28px 0 8px!important;
}
.multiselect__tags .multiselect__single {
  overflow-x: hidden;
  padding: 3px 5px 3px;
  border: 1px solid #f4f4f4;
}
.multiselect__tag {
  margin-bottom: 0;
}
.multiselect__option--selected {
  background-color: #dddddd;
}
.arrow {
  position: absolute;
  right: 10px;
  top: 7px;
  color: #d42e12;
  transition: transform .2s;

  i {
    font-size: 21.6px;
  }
}
.arrow.active {
  -ms-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}
.choiceWithTask {
  float: left;
  width: 100%;
}
.gallery-wrapper {
  border-radius: 3px;

  .gallery-grid {
    display: flex;
    flex-wrap: wrap;
    padding: 0;

    .gallery-item {
      position: relative;
      background-color: transparent;
      color: #fff;
      text-align: center;
      cursor: pointer;
      border-radius: 3px;
      transition: all 0.2s ease-in;
      padding: 0 15px;

      .slide-wrapper {
        margin: 0;
        transition: all 0.2s ease-in;

        &:after {
          transition: all 0.2s ease-in;
        }

        .gallery-img-wrapper {
          max-height: 450px;
          min-height: 450px;
          overflow: hidden;
          transition: all 0.2s ease-in;
          background-color: rgba(255,255,255,1);
          position: relative;
          border: 2px solid #fff;

          .gallery-img {
            width: 100%;
            height: 450px;
            border: 0;
          }

          .lang-legend {
            color: #ff7643;
            text-transform: uppercase;
            font-size: 14px;
            border-radius: 3px;
            font-family: "Source Sans Pro", sans-serif;
            background: linear-gradient(to bottom right, transparent 0%, transparent 50%, #d9d9d9 50%, #d9d9d9 100%);
            width: 45px;
            position: absolute;
            bottom: 0;
            right: 0;
            height: 45px;
            overflow: hidden;
            display: none;

            span {
              transform: rotate(-45deg);
              -ms-transform: rotate(-45deg);
              -webkit-transform: rotate(-45deg);
              display: inline-block;
              position: absolute;
              bottom: 4px;
              right: 5px;
            }
          }
        }

        .gallery-title {
          font-size: 18px;
          font-weight: 600;
          display: block;
          font-family: "Source Sans Pro", sans-serif;
          background-color: rgba(255,118,67,1);
          color: #000;
          transition: all 0.2s ease-in;
          position: absolute;
          top: 48%;
          left: 15px;
          right: 15px;
          padding: 5px 0;
          opacity: 0;
        }
      }

      &:hover {
        .gallery-title {
          opacity: 1;
        }
      }

      &:hover,
      &.selected {
        .gallery-img-wrapper {
          border: 2px solid #ff7643;
        }
      }
    }

    .label {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
.show-desc {
  padding: 8px 30px 6px 15px;
  background-color: #3485FE;
  font-size: 11px;
  font-style: italic;
  color: #fff;
  border: 0;
  position: relative;
  min-height: 27px;
  display: block;

  &.icon-question {
    background-color: transparent;
    color: #3485FE;
    font-size: 13px;
    cursor: pointer;
    display: initial;
    padding: 0;
    line-height: 30px;
  }

  .icon-question {
    vertical-align: middle;
    margin-right: 3px;
    font-size: 13px;
    color: #fff;
  }

  span {
    line-height: 14px;
  }

  button {
    position: absolute;
    right: 6px;
    top: 10px;
    border: 0;
    outline: none;
    background-color: transparent;
    color: #ff7643;
    cursor: pointer;
    font-size: 8px;

    &:hover {
      transition: all 0.2s ease-in;
      color: #fff;
    }
  }
}
</style>
